import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { SessionQuery } from '@app/core/state/session'
import { UserProfileComponent } from '@app/user/dialogs/user-profile/user-profile.component'
import { UserSettingsComponent } from '@app/user/dialogs/user-settings/user-settings.component'
import { combineLatest, Observable, switchMap } from 'rxjs'
import { UnsavedChangesService } from '@app/shared/services/unsaved-changes.service'
import { UserService } from '@app/user/state/user.service'
import { filter, map } from 'rxjs/operators'
import { appConfig } from '@app/app-config'
import { ProjectsService } from '@app/project/state/projects.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>

  hasAdminAccess$: Observable<boolean>
  hasAdminAndUserAdminAccess$: Observable<boolean>

  hasHexCalculationAccess$: Observable<boolean>

  readonly version = appConfig.version

  constructor(
    private sessionQuery: SessionQuery,
    private dialog: MatDialog,
    private unsavedChangesService: UnsavedChangesService,
    private userService: UserService,
    private projectsService: ProjectsService,
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.sessionQuery.isLoggedIn$
    this.hasAdminAccess$ = this.sessionQuery.selectPermission('CanAccessAdminSite')

    this.hasAdminAndUserAdminAccess$ = combineLatest([
      this.sessionQuery.selectPermission('CanAccessAdminSite'),
      this.sessionQuery.selectPermission('CanAdministrateUsers'),
    ]).pipe(map(([hasAdmin, hasUserAdmin]) => hasAdmin && hasUserAdmin))

    this.hasHexCalculationAccess$ = this.isLoggedIn$.pipe(
      filter(value => value),
      switchMap(() => this.userService.getSettings()),
      map(user => user.UserGroups.some(g => g.Name === 'HexCalculation')),
    )
  }

  exportUsageStatistics(): void {
    this.projectsService.exportUsageStatistics()
  }

  openUserProfile(): void {
    this.dialog.open(UserProfileComponent, {
      panelClass: 'app-no-padding-dialog',
      minWidth: '400px',
    })
  }

  openUserSettings(): void {
    this.unsavedChangesService.checkAndRequestActionForUnsavedChanges().subscribe(canProceed => {
      if (!canProceed) {
        return
      }
      this.dialog.open(UserSettingsComponent, {
        minWidth: '720px',
        maxWidth: '1200px',
      })
    })
  }
}
